import { createFileRoute } from '@tanstack/react-router'

import { CarrierPage } from '#/modules/carriers/carrier-page'

export const Route = createFileRoute('/_shell/carriers/$carrierId')({
  component: function CarrierPageRoute() {
    const { carrierId } = Route.useParams()
    return <CarrierPage carrierId={carrierId} />
  },
})
